import HttpService from "@/utils/httpData"

export const savePostClassSchool = params => {
    let apiEndpoint = `PostClassSchool/Create`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const listPostClassSchool = params => {
    let apiEndpoint = `PostClassSchool/List`;
    return HttpService.post(apiEndpoint, params).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const getDetail = id => {
    let apiEndpoint = `PostClassSchool/detail?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
export const deletePostClassSchool = id => {
    let apiEndpoint = `PostClassSchool/Delete?id=${id}`;
    return HttpService.get(apiEndpoint).then(res => {
        return res.data ? res.data : null;
    }).catch(e => { return false });
}
